/* Go-Tone accessory pages (templates/product.accessory.json): quantity stepper, variant select,
 * add to cart for the buy box and the quick add cards, and the "Other attachments" arrows.
 * Posts to /cart/add.js, then opens the Kaching cart drawer when it is on the page, otherwise
 * goes to the cart page. Vanilla ES2018, event delegation, safe to load more than once. */
(function () {
  if (window.GTA_ACCESSORY_READY) return;
  window.GTA_ACCESSORY_READY = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function setLabel(button, text) {
    var label = button.querySelector('[data-gta-add-text]');
    if (label) label.textContent = text;
  }

  function addToCart(variantId, quantity) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: quantity }] })
    }).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (data) {
        if (!response.ok || data.status) throw new Error(data.description || data.message || 'add failed');
        return data;
      });
    });
  }

  function announceCart(variantId) {
    try {
      if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'gta-accessory', productVariantId: variantId });
      }
    } catch (e) {
      /* the theme's pub/sub only refreshes the cart count; never block the add on it */
    }
  }

  function openCart() {
    var kaching = window.kachingCartApi;
    if (kaching && typeof kaching.openCart === 'function') {
      var refresh = typeof kaching.refreshCart === 'function' ? Promise.resolve(kaching.refreshCart()) : Promise.resolve();
      return refresh.catch(function () {}).then(function () { kaching.openCart(); });
    }
    window.location.href = root + 'cart';
    return Promise.resolve();
  }

  function quantityFor(button) {
    if (button.hasAttribute('data-quick')) return 1;
    var scope = button.closest('[data-gta-product]');
    var input = scope && scope.querySelector('[data-gta-qty]');
    var qty = input ? parseInt(input.value, 10) : 1;
    return isNaN(qty) || qty < 1 ? 1 : Math.min(qty, 20);
  }

  document.addEventListener('click', function (event) {
    var step = event.target.closest('[data-gta-qty-step]');
    if (step) {
      var input = step.parentElement.querySelector('[data-gta-qty]');
      var next = (parseInt(input.value, 10) || 1) + parseInt(step.getAttribute('data-gta-qty-step'), 10);
      input.value = Math.max(1, Math.min(20, next));
      return;
    }

    var arrow = event.target.closest('[data-gta-scroll]');
    if (arrow) {
      var carousel = arrow.closest('[data-gta-carousel]');
      var track = carousel && carousel.querySelector('[data-gta-track]');
      if (track) {
        var card = track.firstElementChild;
        var distance = card ? card.getBoundingClientRect().width + 16 : track.clientWidth;
        track.scrollBy({ left: distance * parseInt(arrow.getAttribute('data-gta-scroll'), 10), behavior: 'smooth' });
      }
      return;
    }

    var button = event.target.closest('[data-gta-add]');
    if (!button || button.disabled || button.classList.contains('is-loading')) return;

    var scope = button.closest('[data-gta-product]');
    var error = scope && scope.querySelector('[data-gta-error]');
    var variantId = button.getAttribute('data-variant-id');
    var label = button.getAttribute('data-label');
    if (error) error.hidden = true;
    button.classList.add('is-loading');
    if (!button.hasAttribute('data-quick')) setLabel(button, button.getAttribute('data-adding') || label);

    addToCart(variantId, quantityFor(button))
      .then(function () {
        announceCart(variantId);
        button.classList.remove('is-loading');
        setLabel(button, label);
        if (button.hasAttribute('data-quick')) {
          button.classList.add('is-added');
          setTimeout(function () { button.classList.remove('is-added'); }, 2000);
        }
        return openCart();
      })
      .catch(function () {
        button.classList.remove('is-loading');
        setLabel(button, label);
        if (error) error.hidden = false;
      });
  });

  document.addEventListener('change', function (event) {
    var qtyInput = event.target.closest('[data-gta-qty]');
    if (qtyInput) {
      var value = parseInt(qtyInput.value, 10);
      qtyInput.value = isNaN(value) ? 1 : Math.max(1, Math.min(20, value));
      return;
    }

    var select = event.target.closest('[data-gta-variant]');
    if (!select) return;
    var option = select.options[select.selectedIndex];
    var scope = select.closest('[data-gta-product]');
    var button = scope.querySelector('.gta__atc[data-gta-add]');
    var price = scope.querySelector('[data-gta-price]');
    var compare = scope.querySelector('[data-gta-compare]');
    var available = option.getAttribute('data-available') === 'true';
    button.setAttribute('data-variant-id', option.value);
    button.disabled = !available;
    setLabel(button, available ? button.getAttribute('data-label') : button.getAttribute('data-sold-out'));
    if (price) price.textContent = option.getAttribute('data-price');
    if (compare) {
      compare.textContent = option.getAttribute('data-compare');
      compare.hidden = !option.getAttribute('data-compare');
    }
  });
})();
